import { IHttpService, IPromise } from 'angular';
import { GmcApi } from '../../constants/gmc-api';
import {
  IPaymentData,
  IPaymentReqData,
  IWithdrawalReqData
} from './payment.interfaces';
import { ApiService } from '../api-service/api.service';
import { ICashflow } from '../../entities/cashflow';

export interface IBalance {
  coins?: number;
  money?: number;
  earned?: number;
  personal?: number;
}

export interface IPaginationRes {
  pages: number;
}

export interface IPaymentTransactionRes extends IPaginationRes {
  payments: IPaymentTransaction[];
}

export interface IPaymentTransaction {
  buy_plan: any;
  currency: string;
  date: Date;
  info: string;
  money: number;
  status: string;
  type: string;
  user_id: string;
  _id: string;
}

export interface IPaymentTransactionParams {
  page?: number;
  date_from?: Date;
  date_to?: Date;
  payment_purpose?: string;
  currency?: string;
  limit?: number;
}

export class PaymentService {
  static $inject = ['ApiService', '$http', 'GmcApi'];
  balance: IBalance = {
    coins: 0,
    earned: 0,
    money: 0,
    personal: 0
  };

  constructor(
    private apiService: ApiService,
    private $http: IHttpService,
    private gmcApi: GmcApi
  ) {}

  getBalance(): IPromise<IBalance> {
    return this.apiService
      .get<IBalance>('/payments/getMyBalance')
      .then((balance) => {
        this.balance = balance;
        console.log(this.balance);
        return this.balance;
      });
  }

  getPaymentsActions(): IPromise<any> {
    return this.$http
      .get<any>(this.gmcApi.payments.getPaymentsActions)
      .then((res) => {
        return res.data;
      });
  }

  getPaymentData(data: IPaymentReqData): IPromise<IPaymentData> {
    return this.$http
      .post<{ paymentObject: IPaymentData }>(
        this.gmcApi.payments.createPaymentEx,
        data
      )
      .then((res) => res.data.paymentObject);
  }

  getPaymentsHistory(
    params: IPaymentTransactionParams = {}
  ): IPromise<IPaymentTransactionRes> {
    return this.$http
      .get<IPaymentTransactionRes>(this.gmcApi.payments.paymentsHistory, {
        params
      })
      .then((res) => {
        res.data.payments.map((transaction) => {
          transaction.date = transaction.date
            ? new Date(transaction.date)
            : null;
          return transaction;
        });
        return res.data;
      });
  }

  getPaymentPurpose() {
    return this.apiService.get('/payments/getPaymentPurpose').then((res) => {
      return res;
    });
  }

  getWithdrawValues(): IPromise<IWithdrawalReqData> {
    return this.$http
      .get<IWithdrawalReqData>(this.gmcApi.payments.getWithdrawValues)
      .then((res) => {
        return res.data;
      });
  }

  getCashFlowSummary(): IPromise<ICashflow> {
    return this.apiService
      .get('/payments/getCashFlowSummary')
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getInvoice(id: string): IPromise<any> {
    return this.apiService.get('/pdf/invoice/' + id, {responseType: 'arraybuffer' }).then((res) => {
      return res;
    });
  }
}



// WEBPACK FOOTER //
// ./app/core/services/payment/payment.service.ts